<template>
  <div class="customize">
    <div class="module1">
      <div class="box f-b-c">
        <div class="left">
          <h1>
            <div class="title1">{{ $t('Customize.Module1.Title1') }}</div>
            <div class="title2">{{ $t('Customize.Module1.Title2') }}</div>
          </h1>
          <div class="sub sub1">{{ $t('Customize.Module1.Sub1') }}</div>
          <el-button class="btn" @click="$router.push('/customizedAdd')">{{ $t('Customize.Module1.Btn') }}</el-button>
        </div>
        <div class="right">
          <oss-img :width="698" :height="498" src="https://img.kakaclo.com/web-img/home/customize/pic_img1.png" />
        </div>
      </div>
    </div>
    <div class="module2">
      <div class="title">{{ $t('Customize.Module2.Title1') }}</div>
      <div class="sub">{{ $t('Customize.Module2.Sub1') }}</div>
      <div class="bg">
        <div class="box">
          <div v-if="isPC" class="top f-b-c">
            <div class="list">
              <div v-for="(item, i) in list" :key="item.title" class="item" :class="{ sel: selIndex === i }" @click="selIndex = i">
                {{ $t(item.title) }}
              </div>
            </div>
            <div class="right">
              <oss-img :width="1000" :height="512" :src="`https://img.kakaclo.com/web-img/home/customize/pic_img${selIndex + 2}.png`" />
            </div>
          </div>
          <div v-else class="top">
            <div v-for="(item, i) in list" :key="item.title" class="item">
              <oss-img :width="343" :height="176" :src="`https://img.kakaclo.com/web-img/home/customize/pic_img${i+2}.png`" />
              <div class="title1">{{ $t(item.title) }}</div>
            </div>
          </div>
          <div class="bottom">
            <div class="title">{{ $t('Customize.Module2.Title7') }}</div>
            <div class="box1 f-b-c">
              <div class="item">
                <div class="img">
                  <oss-img :width="698" :height="498" src="https://img.kakaclo.com/web-img/home/customize/pic_img7.png" />
                </div>
                <div class="box2">
                  <div class="title1">{{ $t('Customize.Module2.Title8') }}</div>
                  <div class="sub">{{ $t('Customize.Module2.Sub2') }}</div>
                </div>
              </div>
              <div class="item">
                <div class="img">
                  <oss-img :width="698" :height="498" src="https://img.kakaclo.com/web-img/home/customize/pic_img8.png" />
                </div>
                <div class="box2">
                  <div class="title1">{{ $t('Customize.Module2.Title9') }}</div>
                  <div class="sub">{{ $t('Customize.Module2.Sub3') }}</div>
                </div>
              </div>
              <div class="item">
                <div class="img">
                  <oss-img :width="698" :height="498" src="https://img.kakaclo.com/web-img/home/customize/pic_img9.png" />
                </div>
                <div class="box2">
                  <div class="title1">{{ $t('Customize.Module2.Title10') }}</div>
                  <div class="sub">{{ $t('Customize.Module2.Sub4') }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="module3">
      <div class="box">
        <div class="title">{{ $t('Customize.Module3.Title1') }}</div>
        <div class="sub">{{ $t('Customize.Module3.Sub1') }}</div>
        <div class="img">
          <oss-img :width="1400" :height="400" src="https://img.kakaclo.com/web-img/home/customize/pic_img10.png" />
        </div>
      </div>
    </div>
    <div class="module4">
      <div class="box">
        <div class="title">{{ $t('Customize.Module4.Title1') }}</div>
        <div class="box1 f-b-c">
          <div class="item">
            <div class="title1">8,600+</div>
            <div class="sub1">{{ $t('Customize.Module4.Sub1') }}</div>
          </div>
          <div class="item">
            <div class="title1">11,000+</div>
            <div class="sub1">{{ $t('Customize.Module4.Sub2') }}</div>
          </div>
          <div class="item">
            <div class="title1">Low MOQ</div>
            <div class="sub1">{{ $t('Customize.Module4.Sub3') }}</div>
          </div>
          <div class="item">
            <div class="title1">24/7</div>
            <div class="sub1">{{ $t('Customize.Module4.Sub4') }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="module5">
      <div class="title">{{ $t('Customize.Module5.Title') }}</div>
      <div v-if="isPC" class="box f-b-c">
        <div v-for="item in 12" :key="item" class="item">
          <div class="img">
            <oss-img :width="332" :height="376" :src="`https://img.kakaclo.com/web-img/home/customize/pic_custom${item}.png`" />
          </div>
          <div class="box1 f-b-c">
            <div class="title1">{{ $t(`Customize.Module5.Title${item}`) }}</div>
            <div class="sub">{{ $t(`Customize.Module5.Sub${item}`) }}</div>
            <el-button type="text" class="btn" @click="$router.push('/customizedAdd')">{{ $t('Customize.Module5.Btn') }}</el-button>
          </div>
        </div>
      </div>
      <template v-else>
        <div class="mobile-item">
          <div class="img f-b-c">
            <oss-img :width="342" :height="342" :src="`https://img.kakaclo.com/web-img/home/customize/pic_custom13.png`" />
          </div>
          <div v-for="t in 4" :key="t" class="item-text">
            <div class="dot"></div>
            <span class="title1">{{ $t(`Customize.Module5.Title${t}`) }} - </span>
            <span class="sub">{{ $t(`Customize.Module5.Sub${t}`) }}</span>
          </div>
          <el-button type="primary" class="btn" @click="$router.push('/customizedAdd')">{{ $t('Customize.Module5.Btn') }}</el-button>
        </div>
        <div class="mobile-item">
          <div class="img f-b-c">
            <oss-img :width="342" :height="342" :src="`https://img.kakaclo.com/web-img/home/customize/pic_custom14.png`" />
          </div>
          <div v-for="t in 4" :key="t" class="item-text">
            <div class="dot"></div>
            <span class="title1">{{ $t(`Customize.Module5.Title${t+4}`) }} - </span>
            <span class="sub">{{ $t(`Customize.Module5.Sub${t+4}`) }}</span>
          </div>
          <el-button type="primary" class="btn" @click="$router.push('/customizedAdd')">{{ $t('Customize.Module5.Btn') }}</el-button>
        </div>
        <div class="mobile-item">
          <div class="img f-b-c">
            <oss-img :width="342" :height="342" :src="`https://img.kakaclo.com/web-img/home/customize/pic_custom15.png`" />
          </div>
          <div v-for="t in 4" :key="t" class="item-text">
            <div class="dot"></div>
            <span class="title1">{{ $t(`Customize.Module5.Title${t+8}`) }} - </span>
            <span class="sub">{{ $t(`Customize.Module5.Sub${t+8}`) }}</span>
          </div>
          <el-button type="primary" class="btn" @click="$router.push('/customizedAdd')" style="margin-bottom: 10px;">{{ $t('Customize.Module5.Btn') }}</el-button>
        </div>
      </template>
    </div>
    <div class="module6">
      <div class="box">
        <div class="title">{{ $t('Customize.Module6.Title1') }}</div>
        <div class="sub">{{ $t('Customize.Module6.Sub1') }}</div>
        <div class="banner">
          <el-carousel :interval="4000" type="card" indicator-position="none" :height="isPC?'400px':'200px'">
            <el-carousel-item v-for="img in carouselArr" :key="img">
              <div class="img">
                <oss-img :src="img" :width="528" :height="400" style="width:100%"></oss-img>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <div class="module7">
      <promotion-blog :list="customization" :title="$t('Customize.Module7.Title1')"></promotion-blog>
      <!-- <div class="title">{{ $t('Customize.Module7.Title1') }}</div>
      <div class="box f-b-c">
        <div class="item" v-for="item in customization" :key="item.type">
          <div class="img">
            <oss-img :width="332" :height="376" :src="item.img_url" alt="img" />
          </div>
          <div class="type f-c-c">{{ item.type }}</div>
          <div class="title1 ellipsis2">{{ item.title }}</div>
          <div class="foot f-b-c">
            <div class="date">{{ item.date }}</div>
            <el-link type="text" class="more" :href="item.url">Read more</el-link>
          </div>
        </div>
      </div> -->
    </div>
    <stylist-module></stylist-module>
    <promotion-module-1></promotion-module-1>
    <div class="module9">
      <div class="title">{{ $t('Customize.Module9.Title') }}</div>
      <div class="box">
        <el-collapse v-model="questions">
          <el-collapse-item :title="$t('Customize.Module9.Title1')" name="1">
            <div class="sub">{{ $t('Customize.Module9.Sub1') }}</div>
          </el-collapse-item>
          <el-collapse-item :title="$t('Customize.Module9.Title2')" name="2">
            <div class="sub">{{ $t('Customize.Module9.Sub2') }}</div>
            <div class="sub">{{ $t('Customize.Module9.Sub3') }}</div>
          </el-collapse-item>
          <el-collapse-item :title="$t('Customize.Module9.Title3')" name="3">
            <div class="sub">{{ $t('Customize.Module9.Sub4') }}</div>
          </el-collapse-item>
          <el-collapse-item :title="$t('Customize.Module9.Title4')" name="4">
            <div class="sub">{{ $t('Customize.Module9.Sub5') }}</div>
          </el-collapse-item>
          <el-collapse-item :title="$t('Customize.Module9.Title5')" name="5">
            <div class="sub">{{ $t('Customize.Module9.Sub6') }}</div>
          </el-collapse-item>
          <el-collapse-item :title="$t('Customize.Module9.Title6')" name="6">
            <div class="sub">{{ $t('Customize.Module9.Sub7') }}</div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
  </div>
</template>

<script>
import API from '@/api'
import StylistModule from '../components/StylistModule.vue'
import PromotionBlog from '../components/PromotionBlog.vue'
import PromotionModule1 from '../components/PromotionModule1.vue'
export default {
  metaInfo: {
    title: 'Boutique Custom Clothing Suppliers – KakaClo',
    meta: [
      {
        name: 'description',
        content: 'Leading wholesale custom fashion clothing supplier, personalizing custom T-shirts, polo shirts, hoodies with labels and branding.'
      }
    ]
  },
  components: { StylistModule, PromotionBlog, PromotionModule1 },
  data() {
    return {
      selIndex: 0,
      list: [
        {
          title: 'Customize.Module2.Title2',
          img: 'https://img.kakaclo.com/web-img/home/customize/pic_img3.png'
        },
        {
          title: 'Customize.Module2.Title3',
          img: 'https://img.kakaclo.com/web-img/home/customize/pic_img4.png'
        },
        {
          title: 'Customize.Module2.Title4',
          img: 'https://img.kakaclo.com/web-img/home/customize/pic_img5.png'
        },
        {
          title: 'Customize.Module2.Title5',
          img: 'https://img.kakaclo.com/web-img/home/customize/pic_img6.png'
        },
        {
          title: 'Customize.Module2.Title6',
          img: 'https://img.kakaclo.com/web-img/home/customize/pic_img7.png'
        }
      ],
      carouselArr: [
        'https://img.kakaclo.com/web-img/home/customize/pic_img11.png',
        'https://img.kakaclo.com/web-img/home/customize/pic_img12.png',
        'https://img.kakaclo.com/web-img/home/customize/pic_img13.png'
      ],
      questions: ['1'],
      customization: []
    }
  },
  created() {
    this.getPromotionLatestBlog()
  },
  methods: {
    getPromotionLatestBlog() {
      API.getPromotionLatestBlog().then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        this.customization = res.data.Customization
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.customize {
  color: #303133;
  background-color: #fff;
  .box {
    max-width: 1420px;
    margin: 0 auto;
    padding: 0 20px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .title {
    font-size: 36px;
    line-height: 48px;
    font-weight: 600;
    margin-bottom: 16px;
    text-align: center;
  }
  .sub {
    font-size: 16px;
    line-height: 24px;
    color: #606266;
    width: 880px;
    text-align: center;
    margin: 0 auto;
  }
  .module1 {
    padding: 100px 0;
    background-image: url('https://img.kakaclo.com/web-img/home/customize/bg_img1.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .left {
      .title1,.title2 {
        font-size: .48rem;
        line-height: .68rem;
        font-weight: bold;
        width: unset;
      }
      .title2 {
        color: #9AC331;
      }
      .sub1 {
        margin-top: 16px;
        text-align: left;
        width: unset;
      }
      .btn {
        background: linear-gradient( 90deg, #E7E140 0%, #9AC331 100%);
        border-radius: 4px;
        color: #fff;
        height: 50px;
        box-sizing: border-box;
        padding: 0 32px;
        margin-top: 80px;
      }
    }
    .right{
      width: 50%;
    }
  }
  .module2 {
    margin-top: 100px;
    .bg {
      margin-top: 56px;
      background-image: url('https://img.kakaclo.com/web-img/home/customize/bg_img1.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;

      .top {
        height: 512px;
        width: 100%;
        .list {
          border-left: 1px solid #E1E4EA;
          width: 320px;
          height: 100%;
          .item {
            width: 320px;
            height: 52px;
            margin-bottom: 8px;
            color: #909399;
            position: relative;
            font-size: 20px;
            line-height: 52px;
            padding: 0 20px;
            cursor: pointer;
          }
          .item:hover {
            background-color: #F5F7F7;
          }
          .sel {
            background-color: #F5F9EA !important;
            color: #9AC331;
            border-left: 1px solid #9AC331;
          }
        }
        .right {
          width: 73%;
        }
      }

      .bottom {
        padding: 208px 0 104px 0;
        .title {
          margin-bottom: 56px;
        }
        .box1 {
          .item {
            width: 32%;
            background: #FFFFFF;
            box-shadow: 0px 6px 30px 5px rgba(77,150,59,0.02), 0px 16px 24px 2px rgba(77,150,59,0.02), 0px 8px 10px -5px rgba(77,150,59,0.04);
            border-radius: 12px;
            .title1 {
              font-size: 24px;
              font-weight: 600;
              margin-bottom: 12px;
              text-align: center;
            }
            .img {
              width: 100%;
            }
            .box2 {
              width: 100%;
              height: 172px;
              box-sizing: border-box;
              padding: 24px 20px;
              .sub {
                width: 100%;
              }
            }
          }
        }
      }

    }
  }
  .module3 {
    padding: 104px 0;
    .img {
      width: 100%;
      margin-top: 56px;
    }
  }
  .module4 {
    background-image: url('https://img.kakaclo.com/web-img/home/customize/bg_img3.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    padding: 104px 0;
    .title {
      color: #fff;
      margin-bottom: 56px;
    }
    .item {
      width: 22%;
    }
    .title1 {
      color: #9AC331;
      font-size: 48px;
      font-weight: 600;
      margin-bottom: 12px;
    }
    .sub1 {
      font-size: 20px;
      line-height: 28px;
      color: #fff;
      height: 56px;
    }
  }
  .module5 {
    padding: 104px 0;
    .title {
      margin-bottom: 56px;
    }
    .box {
      flex-wrap: wrap;
    }
    .item {
      width: 24%;
      margin-bottom: 24px;
      overflow: hidden;
      position: relative;
      border-radius: 12px;
      .box1 {
        width: 100%;
        height: 100%;
        position: absolute;
        padding: 32px 24px;
        top: 80%;
        background-color: #F5F7F7;
        font-size: 18px;
        flex-direction: column;
        align-items: flex-start;
        .title1 {
          font-size: 18px;
        }
        .sub {
          margin: 24px 0;
          width: 100%;
          max-height: 210px;
          text-align: left;
          flex: 1;
        }
        .btn {
          padding: 0;
        }
      }
      .box1:hover {
        top: 0;
        transition: .6s all;
      }
    }
  }
  .module6 {
    padding: 104px 0;
    background: linear-gradient( 180deg, #ECF8F0 0%, rgba(236,248,240,0) 100%);
    .banner {
      margin-top: 56px;
      .img {
        width: 100%;
      }
      /deep/ .el-carousel__item {
        border-radius: 12px !important;
      }
    }
  }
  .module7 {
    padding: 104px 0;
  }
  .module9 {
    padding: 104px 0;
    .title {
      margin-bottom: 56px;
    }
    .box {
      /deep/ .el-collapse {
        border-top: 0;
      }
      /deep/ .el-collapse-item__header {
        font-size: 16px;
        line-height: 24px;
        padding: 12px 0;
        font-weight: 500;
        height: unset;
      }
      .sub {
        width: unset;
        text-align: left;
      }
    }
  }

  @media screen and (max-width: 1000px) {
    .box {
      padding: 0 16px;
    }
    .title {
      font-size: 20px;
      line-height: 28px;
      margin-bottom: 12px;
      font-weight: 600;
    }
    .sub {
      width: unset;
      font-size: 14px;
      line-height: 22px;
      color: #606266;
      text-align: center;
    }
    .module1 {
      padding: 40px 0;
      .box {
        flex-direction: column;
        // align-items: flex-start;
        .left {
          text-align: center;
        }
        .title1,.title2 {
          // font-size: .48rem;
          font-size: 28px;
          line-height: 36px;
        }
        .sub {
          margin-top: 12px;
          text-align: center;
        }
        .btn {
          margin: 40px 0;
        }
        .right {
          width: 100%;
        }
      }
    }
    .module2 {
      margin-top: 48px;
      .title,.sub {
        padding: 0 16px;
      }
      .bg {
        background: unset;
        .top {
          height: unset;
          .title1 {
            font-size: 16px;
            line-height: 24px;
            margin: 16px 0 32px 0;
            text-align: center;
            font-weight: 500;
          }
        }
        .bottom {
          padding: 60px 0 48px 0;
          .title {
            margin-bottom: 0;
          }
          .box1 {
            flex-direction: column;
            .item {
              margin-top: 32px;
              width: 100%;
              .box2 {
                padding: 20px;
                padding-bottom: 26px;
                height: unset;
                .title1 {
                  margin-bottom: 8px;
                  font-size: 18px;
                  line-height: 26px;
                  font-weight: 600;
                }
                .sub {
                  color: #909399;
                }
              }
            }
          }
        }
      }
    }
    .module3 {
      margin: 48px 0;
      padding: 0;
      .title {
        margin-bottom: 12px;
      }
      .img {
        margin-top: 32px;
      }
    }
    .module4 {
      background-image: url('https://img.kakaclo.com/web-img/home/customize/bg_img5.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      padding: 48px 0;
      .title {
        margin-bottom: 0;
      }
      .box1 {
        flex-wrap: wrap;
        .item {
          width: 48%;
          margin-top: 32px;
          .title1 {
            font-size: 28px;
            line-height: 36px;
            margin-bottom: 4px;
          }
          .sub1 {
            font-size: 14px;
            line-height: 22px;
          }
        }
      }
    }
    .module5 {
      padding: 48px 16px;
      padding-bottom: 30px;
      .title {
        margin-bottom: 32px;
      }
      .mobile-item {
        .img {
          width: 100%;
          height: auto;
          flex-wrap: wrap;
          border-radius: 12px;
          >img {
            width: 100%;
            height: 100%;
          }
        }
        .item-text {
          margin-top: 16px;
          padding-left: 14px;
          position: relative;
          .dot {
            position: absolute;
            width: 5px;
            height: 5px;
            background-color: #303133;
            top: 7px;
            left: 3px;
            border-radius: 50%;
          }
        }
        .title1 {
          font-size: 14px;
          line-height: 20px;
          font-weight: 500;
        }
        .sub {
          font-size: 12px;
          line-height: 16px;
          text-align: left;
          margin-bottom: 12px;
        }
        .btn {
          padding: 10px 20px;
          font-size: 13px;
          line-height: 20px;
          margin: 18px 0 32px 0;
        }
      }
    }
    .module6 {
      padding: 48px 0;
      padding-bottom: 30px;
      .banner {
        margin-top: 32px;
        /deep/ .el-carousel__item {
          border-radius: 6px !important;
          img {
            border-radius: 6px !important;
          }
        }
      }
    }
    .module7 {
      padding: 20px 0 48px 0;
    }
    .module9 {
      padding: 48px 0;
      .title {
        margin-bottom: 20px;
      }
      /deep/ .el-collapse-item__header {
        font-size: .20rem;
        line-height: .28rem;
        padding: 40px 0;
        height: unset;
      }
      .sub {
        width: unset;
        text-align: left;
      }
    }
  }
}

</style>
